import PropTypes from 'prop-types';
import * as ALOOMA from 'consts/alooma';
import Modal from 'components/templates/Modal/Modal';
import ModalBodyWithdrawPaypalBlockedByGiftCard from 'components/molecules/ModalBodyWithdrawPaypalBlockedByGiftCard/ModalBodyWithdrawPaypalBlockedByGiftCard';

const ModalWithdrawPaypalBlockedByGiftCard = props => {
  const { closeModal, sourcePage } = props;

  return (
    <Modal
      source={sourcePage}
      aloomaModalType={ALOOMA.MODAL_TYPES.POPUP}
      aloomaModalName={ALOOMA.MODAL_NAMES.WITHDRAW_PAYPAL_BLOCKED_BY_GIFT_CARD}
      onClose={closeModal}
      sendPageView={false}
    >
      <ModalBodyWithdrawPaypalBlockedByGiftCard {...props} />
    </Modal>
  );
};

ModalWithdrawPaypalBlockedByGiftCard.propTypes = {
  closeModal: PropTypes.func.isRequired,
  sourcePage: PropTypes.string.isRequired,
};

export default ModalWithdrawPaypalBlockedByGiftCard;
